import Slider from 'react-slick';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './weconnect.css';
import { scrollIntoView } from './ScrollHelper';
const data = require('./lang/lang.json');

class Confused extends Component {
  state = {
    showItem: '',
    prefix: "confused",
    next: "someone",
    mainImage: "images/confused/main.png",
  };

  render() {
    const text = data[localStorage.getItem('language')];
    const slickerSettings = {
      customPaging: (i) => {
        if (i > 4) {
          return <div></div>;
        } else {
          return <button>i</button>;
        }
      },
      slidesToShow: 5,
      slidesToScroll: 1,
      speed: 500,
      centerPadding: '0',
      centerMode: true,
      centerMargin: '0',
      variableWidth: false,
      className: 'bem',
      adaptiveHeight: false,
      autoplay: true,
      dots: true,
      arrow: false,
      autoplaySpeed: 2500,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerPadding: '0',
            centerMode: true,
            centerMargin: '0',
            slidesToShow: 3,
            slidesToScroll: 0,
            adaptiveHeight: false,
            dots: true,
            arrow: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            centerPadding: '0',
            centerMode: true,
            centerMargin: '0',
            slidesToShow: 1,
            slidesToScroll: 0,
            adaptiveHeight: false,
            dots: true,
            arrow: false,
          },
        },
      ],
    };
    const prefix = this.state.prefix
    const next = this.state.next
    const mainImage = this.state.mainImage
    const description = {
        en:"\"We gathered in Yerevan at the beginning of spring. We are Russians and Belarusians who left  their countries in Ukraine after the start of war. The open call of the theater \"Tech Degh\" brought us together to create a documentary project. This is the first experience of our joint work. First of all, the material of the performance is ourselves. our stories, our reflections, our communication with relatives and each other, as well as the interviews we took from emigrants like us, Ukrainian refugees, residents of Armenia, which reflect the history of the war in Artsakh.</br> We're deliberately abandoning a single narrative because our reality now looks more like a social media stream where the monstrous follows the ordinary. Our reality is fragmented,damaged, its integrity is violated by the war. These fragments connect to a heterogeneous canvas, where episodes from conversations, letters, news are randomly included. That canvas is subject to change, and our presentation is only a fixation of the moment of the day. After all, we are on the road, and we don't know where we will end up tomorrow.</br>\"Confused man\" is each of us, dislocated from his place, with collapsed life plans, in complete uncertainty about the future and full of fear for the present.</br>\"The R Group\""
        ,
        arm:"«Մենք Երևանում հավաքվեցինք գարնան սկզբին։ Մենք ռուսներ և բելառուսներ ենք, ովքեր լքել են իրենց երկրները Ուկրաինայում՝ ռազմական գործողությունների սկսելուց հետո։ «Թեք տեղ» թատրոնի բաց կանչը մեզ հավաքեց միասին վավերագրական նախագիծ ստեղծելու համար: Սա մեր համատեղ աշխատանքի առաջին փորձն է։ Ներկայացման նյութը առաջին հերթին մենք ինքներս ենք. մեր պատմությունները, մեր մտորումները, մեր շփումը հարազատների և միմյանց հետ, ինչպես նաև հարցազրույցները, որոնք վերցրել ենք մեզ նման էմիգրանտներից, ուկրաինացի փախստականներից, Հայաստանի բնակիչներից, որոնք արտացոլում են Արցախում տեղի ունեցած պատերազմի պատմությունը։</br> Մենք միտումնավոր հրաժարվում ենք մեկ պատումից, քանի որ այժմ մեր իրականությունն ավելի շատ նման է սոցիալական ցանցերի հոսքի, որտեղ զարհուրելին շարունակում է սովորականին: Մեր իրականությունը բեկորային է, վնասված, նրա ամբողջականությունը խախտված է պատերազմով։ Այս բեկորները միանում են տարասեռ կտավին, ուր պատահականության սկզբունքով ներառված են դրվագներ զրույցներից, նամակագրություններից, լուրերից: Այդ կտավը ենթակա է փոփոխման, իսկ մեր ներկայացումը միայն օրվա պահի ամրագրումն է։ Ի վերջո, մենք ճանապարհին ենք, և չգիտենք, թե որտեղ կհայտնվենք վաղը։ «Շփոթված մարդ» է մեզանից յուրաքանչյուրը՝ քաղհանված իր տեղից, կյանքի փլուզված ծրագրերով,    ապագայի առջև կատարյալ անորոշության մեջ ու սարսափով լցված առ ներկան։»</br> «Ռ խումբ»"
        
      }
    const images = [
        "images/confused/1.jpg",
        "images/confused/2.jpg",
        "images/confused/3.jpg",
        "images/confused/4.jpg",
    ]
    const enlargedImages = [
        "images/confused/1-enlarged.jpg",
        "images/confused/2-enlarged.jpg",
        "images/confused/3-enlarged.jpg",
        "images/confused/4-enlarged.jpg"
    ]
    return (
      <section className='main-container current-container'>
        <div className='breadcrumb container'>
          <a href='/weplay'>{text.weplay_title}/</a>
          <a href={`/${prefix}`} className='breadcrumb-active'>
            {text[prefix]}
          </a>
        </div>
        <div className='section-details modal-slider slider-centered'>
          <div className='row m-0 position-relative'>
            <div className='white-decoration'>
              <img src='images/white-svg.svg' alt='asv' />
            </div>
            <div className='col-lg-6 p-0 pr-lg-4'>
              <img src={mainImage} alt='master-ohan' />
            </div>
            <div className='main-description-banner col-lg-5 p-lg-0'>
              <p className='mb-0'> {text[prefix]}</p>
              <p> {text[`${prefix}_author`]}</p>
              <div className='info-block'>
                <p dangerouslySetInnerHTML={{ __html: description[[localStorage.getItem('language')]]  }}></p>
                <p dangerouslySetInnerHTML={{ __html: text[`${prefix}_date`] }}></p>

                <p dangerouslySetInnerHTML={{ __html: text[`${prefix}_cast`]}}></p>
                <a
                  href='#!'
                  onClick={() => scrollIntoView(`video-link-${prefix}`)}
                  className='info-link  d-block mb-2 mt-3'
                >
                  {text.video_soon}
                </a>
              </div>
            </div>
            <a href={`/${next}`} className='col-lg-1 p-0 next-page desktop-next'>
              <p> {text.next}</p>
              <img src='images/arrow.svg' alt='' />
            </a>
          </div>

          <Slider {...slickerSettings}>
            {images.map((image, index) => (
                 <div data-toggle='modal' data-target='#GalleryModal'>
                 <img
                   src={image}
                   alt=''
                   data-target='#carouselGallery'
                   data-slide-to={index}
                 />
               </div>
            ))}
          </Slider>
          <div className='modal fade' id='GalleryModal' tabIndex='-1' role='dialog' aria-hidden='true'>
            <div className='modal-dialog' role='document'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                    <span aria-hidden='true'>×</span>
                  </button>
                </div>
                <div className='modal-body'>
                  <div id='carouselGallery' className='carousel slide' data-ride='carousel'>
                    <div className='carousel-inner'>
                    {
                        enlargedImages.map((image, index) =>
                          <div className={`carousel-item ${index === 0 ? 'active':''}`}>
                            <img className='d-block w-100' src={image} alt='' />
                          </div>
                        )
                      }
                    </div>
                    <a className='carousel-control-prev' href='#carouselGallery' role='button' data-slide='prev'>
                      <span className='carousel-control-prev-icon' aria-hidden='true'></span>
                      <span className='sr-only'>Previous</span>
                    </a>
                    <a className='carousel-control-next' href='#carouselGallery' role='button' data-slide='next'>
                      <span className='carousel-control-next-icon' aria-hidden='true'></span>
                      <span className='sr-only'>Next</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <p className='text-center photo-by'>
            {text.images_by} {text.saljco}
          </p>
          <a href={`/${next}`} className='col-lg-1 p-0 next-page mobile-next'>
            <p> {text.next}</p>
            <img src='images/arrow.svg' alt='' />
          </a>
        </div>
      </section>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  setLanguage: (language) => dispatch({ type: 'SET_LANGUAGE', language }),
});

const mapStateToProps = (state) => {
  return { language: state.language };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Confused));
